import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function Profile() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/worker/login");
  };

  const fields = [
    { label: "Full Name", value: user.full_name },
    { label: "Employee ID", value: user.employee_id },
    { label: "Phone Number", value: user.phone },
    { label: "Department", value: user.department },
    { label: "Designation", value: user.designation },
    { label: "Date of Joining", value: user.date_of_joining },
    { label: "Preferred Language", value: user.preferred_language },
  ];

  return (
    <div className="worker-ui min-h-screen bg-white">
      {/* Header */}
      <div className="bg-[#0a2240] text-white px-4 py-6">
        <button
          onClick={() => navigate("/worker/dashboard")}
          className="flex items-center text-white mb-4"
        >
          <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back
        </button>
        <div className="text-center">
          <div className="w-24 h-24 bg-white/10 rounded-full mx-auto mb-4 flex items-center justify-center">
            {user.photo_url ? (
              <img
                src={user.photo_url}
                alt={user.full_name}
                className="w-24 h-24 rounded-full object-cover"
              />
            ) : (
              <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            )}
          </div>
          <h1 className="text-2xl font-bold">{user.full_name}</h1>
          <p className="text-slate-300 mt-1">{user.employee_id}</p>
        </div>
      </div>

      {/* Profile Details */}
      <div className="px-4 py-6">
        <div className="space-y-4">
          {fields.map((field, index) => (
            <div
              key={index}
              className="bg-slate-50 border border-slate-200 rounded-xl p-4"
            >
              <p className="text-sm text-slate-600 font-semibold uppercase tracking-wider mb-1">
                {field.label}
              </p>
              <p className="text-lg text-slate-900 font-medium">
                {field.value || "N/A"}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-8">
          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full h-14 text-lg font-semibold border-2 border-red-500 text-red-600 hover:bg-red-50"
            data-testid="logout-button"
          >
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            LOGOUT
          </Button>
        </div>
      </div>

      <div className="h-24"></div>
    </div>
  );
}
